import { Component, OnInit, OnDestroy } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { SearchCriteria } from './_model/search-criteria';
import { SearchService } from 'src/app/_services/search.service';
import { RESULTS_NOT_FOUND } from 'src/app/_common/product-config';
import { HeaderData } from 'src/app/_models/header-data';
import { Router } from '@angular/router';
import { CommonService } from 'src/app/_services/common.service';
import { StatusCode, Modules, PSIOperators } from 'src/app/_common/_enum/module.enum';

@Component({
  selector: 'app-search',
  templateUrl: './search.component.html',
  styleUrls: ['./search.component.scss']
})
export class SearchComponent implements OnInit, OnDestroy {
  private search: any;
  private results = [];
  private _total$ = new BehaviorSubject<number>(0);
  private loading: boolean = true;
  private criteria: SearchCriteria;
  private selectedAccountIndex = null;

  resultsNotFound = RESULTS_NOT_FOUND;
  hasAccess:boolean = false;

  //Create HeaderData object to show the Data on Blue Header.
  private headerData:HeaderData;

  constructor(private router: Router, private searchService: SearchService, private commonService: CommonService) { }

  ngOnInit() {    
    /* Setting Headers Starts */
    this.headerData = new HeaderData();
    this.setHeaderData();
    /* Setting Headers Ended */
    this.criteria = new SearchCriteria();
    this.search = this.searchService.getSearchStorage();
    
    this.getSearchData();
  }

  setHeaderData(){
    this.headerData.pageTitle = "Search Results";
    this.searchService.header = this.headerData;  
  }

  getSearchData(){
    this.criteria.searchTerm = this.search.searchTerm.trim();
    this.loading = true;
    this.hasAccess = this.commonService.checkPermissions([Modules.AccountSearch, Modules.PolicySearch, Modules.ClaimSearch], PSIOperators.OR);
    if(this.hasAccess){
      let searchSubscription = this.searchService.search(this.criteria).subscribe(searchData => {
        this.loading = false;
        this.results = searchData;
        this._total$.next(searchData.length);
      },
      error=>{
        this.loading = false;
        this.hasAccess = !(error.status == StatusCode.NoAccess);
      });

      this.searchService.runningServices.push(searchSubscription);
    }
    else{
      this.loading = false;
    }
  }

  get total$() { return this._total$.asObservable(); }
  get ModuleEnum() {return Modules}
  getRouterLink(item){
    return (item.itemType.toLowerCase() == "policy")?("/policies/"+item.policyNumber):("/claims/"+item.claimNumber);
  }

  onPageChange(){
    window.scrollTo(0, 0);
  }

  openPolicyOrClaim(result){
    this.searchService.storeAccountData({"accountName": result.accountName, "accountNumber": result.accountNumber, "accountEndorsementsTab": null});
    if(result.claimNumber){
      this.router.navigateByUrl("claims/"+result.claimNumber);
    }else{
      this.router.navigateByUrl("policies/"+result.policyNumber);
    }
  }
  openDirectBill(account){
    this.router.navigateByUrl("accounts/"+account.accountNumber+"/directbill");
  }

  openAccountDetails(account){
    this.searchService.storeAccountData({"accountName": account.accountName, "accountNumber": account.accountNumber, "accountEndorsementsTab": null});
    this.router.navigateByUrl("accounts/"+account.accountNumber);
  }
  ngOnDestroy() {
    this.searchService.runningServices.forEach(subscription =>subscription.unsubscribe());
  }
}
